<script setup lang="ts">
export interface Props {
  warningMessage: string;
  accountReceivablesEmail?: string;
}

const props = defineProps<Props>();
</script>

<template>
  <div class="info-container">
    <p>
      {{ props.warningMessage }}
      <a
        v-if="props.accountReceivablesEmail"
        :href="`mailto:${props.accountReceivablesEmail}?subject=Order submission issue`"
        target="_blank"
        class="highlight-email">
        {{ props.accountReceivablesEmail }}
      </a>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.info-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1440px;
  margin: 1rem auto;
  padding: 0 1rem;
  border-radius: 0.5rem;
  background-color: var(--secondary-color);
  color: var(--secondary-text-color);

  .highlight-email {
    color: var(--secondary-text-color);
    text-decoration: underline;
  }
}
</style>
